import React, { useState } from "react";
import { useLocation } from "react-router-dom";

export default function Navlink({ key, label, href, isButton = false, child = null, isScolled = false, navbar = false }) {
    const [showChild, setShowChild] = useState(false);
    const location = useLocation();
    const { pathname } = location;

    return (
        <div
            key={key}
            className="font-evil text-base md:text-xl 2xl:text-2xl relative group"
            onClick={() => (child ? setShowChild(!showChild) : null)}
        >
            {isButton ? (
                <a
                    href={href}
                    className="px-6 py-3 border border-neutral-600 backdrop-blur-xl bg-white/10 rounded-md"
                >
                    {label}
                </a>
            ) : (
                <a href={href}>{label}</a>
            )}

            {child ? (
                <>
                    <div
                        className={`absolute mt-4 w-full 2xl:w-[125%] bg-white/40 backdrop-blur-lg p-4 text-sm rounded-lg ${!showChild ? "hidden" : pathname === "/registration/form" ? "md:!block hidden" : "md:block hidden"
                            }`}
                    >
                        <ul className="space-y-3">
                            {child.map((value, index) => {
                                if (value.isHide) return null;

                                return (<li key={index + 2}>
                                    <a
                                        href={value.href}
                                        target={value.target || (value.href?.startsWith("http") || value.href?.endsWith(".pdf") ? "_blank" : undefined)}
                                        rel={value.target === "_blank" || value.href?.startsWith("http") || value.href?.endsWith(".pdf") ? "noopener noreferrer" : undefined}
                                        className="text-base md:text-lg 2xl:text-xl"
                                    >
                                        {value.label}
                                    </a>
                                </li>)
                            })}
                        </ul>
                    </div>
                </>
            ) : null}
        </div>
    );
}
